/*******************************************************************
* PAGE        : rootReducer
* REMARKS     : Comman Redux root Reducer
* CREATED ON  : 06-01-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 05-01-2026
********************************************************************/

import { combineReducers } from '@reduxjs/toolkit';
import reduxMasterReducer from './reduxMasterSlice';

const rootReducer = combineReducers({
    reduxMaster: reduxMasterReducer,
});

export default rootReducer;
